var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.411442 2.2539C0.175223 2.01768 0.0512075 1.74013 0.0393964 1.42123C0.0512074 1.10234 0.181128 0.818872 0.429158 0.570842C0.665377 0.334623 0.931124 0.222418 1.2264 0.23423C1.54529 0.24604 1.82285 0.370055 2.05907 0.606275L9.3051 7.8523C9.54132 8.08852 9.65943 8.36017 9.65942 8.66726C9.67124 8.98615 9.55313 9.26962 9.3051 9.51765C9.08069 9.74205 8.80313 9.85426 8.47242 9.85426C8.16534 9.85426 7.89369 9.73615 7.65747 9.49993L0.411442 2.2539ZM0.429159 9.42906C0.157507 9.15741 0.0157751 8.83851 0.00396358 8.47238C0.00396358 8.11805 0.145696 7.79915 0.429159 7.51569L7.53345 0.411394C7.8051 0.139742 8.124 0.00982126 8.49014 0.0216327C8.85628 0.0334438 9.17518 0.175175 9.44683 0.446827C9.73029 0.73029 9.86612 1.04328 9.85431 1.3858C9.85431 1.74013 9.71848 2.05312 9.44683 2.32477L2.34253 9.42906C2.05907 9.71253 1.74017 9.85426 1.38585 9.85426C1.03152 9.85426 0.712622 9.71253 0.429159 9.42906Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.e9761a32aa3438fa33e679e8e03331e0.svg";
export { ForwardRef as ReactComponent };